import React from 'react'

const ChackIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    fill='none'
    version='1.1'
    width='12'
    height='12'
    viewBox='0 0 12 12'
  >
    <defs>
      <clipPath id='master_svg0_70_7010'>
        <rect x='0' y='0' width='12' height='12' rx='0' />
      </clipPath>
    </defs>
    <g clipPath='url(#master_svg0_70_7010)'>
      <g>
        <path
          d='M10.35355,3.853553Q10.42388,3.783227,10.46194,3.691342Q10.5,3.5994561,10.5,3.5Q10.5,3.4507543,10.49039,3.4024549Q10.48078,3.354155,10.46194,3.308658Q10.44309,3.263161,10.41573,3.222215Q10.38837,3.181269,10.35355,3.146447Q10.31873,3.111625,10.27778,3.084265Q10.23684,3.056906,10.19134,3.0380599999999998Q10.14584,3.019215,10.09755,3.009607Q10.04925,3,10,3Q9.90054,3,9.80866,3.0380599999999998Q9.71677,3.07612,9.64645,3.146446L9.64601,3.146886L5,7.79289L2.853553,5.64645Q2.783227,5.5761199999999995,2.691342,5.53806Q2.5994562,5.5,2.5,5.5Q2.4507543,5.5,2.4024549,5.50961Q2.354155,5.51921,2.308658,5.53806Q2.263161,5.55691,2.222215,5.58427Q2.181269,5.61162,2.146447,5.64645Q2.111625,5.68127,2.084265,5.7222100000000005Q2.056906,5.76316,2.0380599999999998,5.80866Q2.019215,5.85416,2.009607,5.90246Q2,5.95075,2,6Q2,6.0994600000000005,2.0380599999999998,6.19134Q2.07612,6.28323,2.146447,6.35355L2.14666,6.35377L4.64645,8.85355Q4.68127,8.88838,4.72222,8.91573Q4.76316,8.94309,4.80866,8.96194Q4.85416,8.98078,4.90246,8.99039Q4.95075,9,5,9Q5.04925,9,5.09755,8.99039Q5.14584,8.98078,5.19134,8.96194Q5.23684,8.94309,5.2777899999999995,8.91573Q5.31873,8.88838,5.35355,8.85355L10.35355,3.853553L10.35355,3.853553Z'
          fillRule='evenodd'
          fill='#FD5C1F'
          fillOpacity='1'
        />
      </g>
    </g>
  </svg>
)

export default ChackIcon
